//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters } from 'vuex';
import utils from '~/utils';

export default {
  name: 'FeatureBanner',

  data() {
    return {
      CDN: process.env.CDN,
      // settings for swiper
      swiperOption: {
        effect: 'coverflow',
        centeredSlides: true,
        slidesPerView: 'auto',
        coverflowEffect: {
          depth: 240,
          modifier: 1,
          rotate: 0,
          slideShadows: true,
          stretch: 40,
        },
        initialSlide: 1,
        speed: 400,
        loop: true,
        loopedSlides: 2,
        resizeObserver: true,
        slideToClickedSlide: true,
        lazy: {
          loadPrevNext: true,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          bulletClass: 'bullet',
          bulletActiveClass: 'bullet-active',
        },
        breakpoints: {
          751: {
            coverflowEffect: {
              stretch: 600,
            },
          },
        },
      },
    };
  },

  computed: {
    ...mapState(['features', 'isMobile']),
    ...mapGetters(['imgSuffix']),
  },

  mounted() {
    this.$nextTick(() => {
      this.handleResize();
    });
    window.addEventListener('resize', this.handleResize);
  },

  methods: {
    handleBtnNextClick() {
      this.$swiper.slideNext();
    },
    handleResize() {
      if (this.$swiper && this.$swiper.params) {
        const ratio = utils.calcRatio();

        this.$swiper.params.coverflowEffect.depth = 240 * ratio;
        if (!this.isMobile) {
          this.$swiper.params.coverflowEffect.stretch = 40 * ratio;
        }
      }
    },
  },
};
